import styled from 'styled-components';
import theme from './BaseButton.theme';

export const BaseButton = styled('span')`
  & .baseButton {
    align-items: center;
    background: ${props => theme(props).background};
    border: none;
    border-radius: ${props => theme(props).radius};
    color: ${props => theme(props).text};
    cursor: pointer;
    display: inline-flex;
    font: 400 ${props => theme(props).fontSize}
      ${props => theme(props).fontFamily};
    justify-content: center;
    min-width: 9.8125rem;
    outline: none;
    padding: 0.6255rem 1.5625rem;
    text-transform:  ${props => theme(props).textTransform};
    transition: 160ms all ${props => theme(props).easing};
    user-select: none;

    &:hover {
      background: ${props => theme(props).hover};

    /* stylelint-disable-next-line */
      & .loadingSpinner svg {
        color: ${props => theme(props).hover};
      }
    }

    &:focus {
      background: ${props => theme(props).focus};
      font-weight: 400;

      /* stylelint-disable-next-line */
      & .loadingSpinner svg {
        color: ${props => theme(props).focus};
      }
    }

    &:disabled {
      background: ${props => theme(props).disablePrimary};
      cursor: not-allowed;
      pointer-events: none;
    }

    /* stylelint-disable-next-line */
    & .loadingSpinner svg {
      color: ${props => theme(props).background};
    }
  }
`;

export const Spinner = styled('div')`
  margin-right: ${props => theme(props).spinnerMargin};
`;
